import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import UIConfig from '@/UIConfig.ts';
import { TelegramCustomStar } from '@/components/common/svg/telegram/TelegramCustomStar.tsx';
import PaywallPopup from '@/components/Popup/PaywallPopup/PaywallPopup.tsx';
import { PaywallTypes, ProductInvoicePlacements } from '@/enums/apiEnums.ts';
import Modal from '@/animations/Modal.tsx';

export const BaitBottomBar: React.FC = () => {
  const { t } = useTranslation();

  const [payWallOpen, setPayWallOpen] = useState(false);

  return (
    <>
      <div
        style={{
          height: 180,
          width: '100%',
          backgroundColor: '#fff',
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          borderBottomLeftRadius: 40,
          borderBottomRightRadius: 40,
          padding: '16px',
          boxSizing: 'border-box',
          display: 'flex',
          gap: 16
        }}
      >
        <div
          style={{
            width: 72,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }}
        >
          <div
            style={{
              width: 72,
              height: 72,
              borderRadius: '50%',
              background: UIConfig.Colors.GradientPremium,
              border: '8px solid #F8F8F8FF',
              display: 'flex',
              flexShrink: 0,
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <TelegramCustomStar width={36} height={36} fillColor="#fff" />
          </div>
        </div>

        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            marginLeft: 5
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              gap: 8
            }}
          >
            <div
              style={{
                fontSize: 17,
                fontWeight: 700,
                color: '#000'
              }}
            >
              {t('chats.bait_bar_title')}
            </div>

            <div
              style={{
                fontSize: 14,
                fontWeight: 400,
                color: '#000',
                marginBottom: 10
              }}
            >
              {t('chats.bait_bar_subtitle')}
            </div>
          </div>

          <motion.button
            whileTap={{ scale: 0.95 }}
            onClick={() => setPayWallOpen(true)}
            style={{
              height: 48,
              width: '100%',
              borderRadius: 24,
              border: 'none',
              background: UIConfig.Colors.GradientPremium,
              color: '#fff',
              fontSize: 17,
              fontWeight: 600,
              cursor: 'pointer'
            }}
          >
            {t('chats.bait_bar_button')}
          </motion.button>
        </div>
      </div>
      <Modal
        fullScreen
        scrollable
        open={payWallOpen}
        handleClose={() => setPayWallOpen(false)}
      >
        <PaywallPopup
          handleClose={() => setPayWallOpen(false)}
          type={PaywallTypes.TYPE_SUBSCRIPTION}
          placement={ProductInvoicePlacements.BAIT_DIALOG}
          hideBackButton={false}
          prevHeaderTemplate="light"
        />
      </Modal>
    </>
  );
};
